export default __webpack_public_path__ + "static/media/image-05.e6c0a424.png";